
<div [ngStyle]="{ 'display' : altitudeFilterController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"  id="ngAltitudeFilterForm" [ngClass]="[this.altitudeFilterController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" name="ngAltitudeFilterForm" #ngAltitudeFilterForm="ngForm">
    <div class="fields__block" style="width: 100%;">
      <div class="fields__block__section">
        <div class="input-fields">
          <div>
            <label for="">Minimum Elevation</label>
            <div class="coordenates"><input type="number" [(ngModel)]="minAltitudeRange" name="minAltitudeRange"/><span>[ft]</span></div>
          </div>
          <div>
            <label for="">Maximum Elevation</label>
            <div class="coordenates"><input type="number" [(ngModel)]="maxAltitudeRange" name="maxAltitudeRange"/><span>[ft]</span></div>
          </div>
          <div class="coordenates">
            <div class="checkboxs">
              <input
                type="checkbox"
                id="coverageCheckbox"
                name="CoverageCheckbox"
                [(ngModel)]="checkboxCoverage"
              />
              <label for="coverageCheckbox">Coverage</label>
            </div>

            <div class="checkboxs">
              <input
                type="checkbox"
                id="impact"
                name="impact"
                [(ngModel)]="checkboxImpact"
              />
              <label for="impact">Impact Assessment</label>
            </div>

<!--            <div class="checkboxs">-->
<!--              <input-->
<!--                type="checkbox"-->
<!--                id="cumulativeCoverageCheckbox"-->
<!--                name="CumulativeCoverageCheckbox"-->
<!--                [(ngModel)]="checkboxCumulativeCoverage"-->
<!--              />-->
<!--              <label for="cumulativeCoverageCheckbox">Cumulative Coverage</label>-->
<!--            </div>-->
<!--            <div class="checkboxs">-->
<!--              <input-->
<!--                type="checkbox"-->
<!--                id="performanceCheckbox"-->
<!--                name="PerformanceCheckbox"-->
<!--                [(ngModel)]="checkboxPerformance"-->
<!--              />-->
<!--              <label for="performanceCheckbox">Performance</label>-->
<!--            </div>-->
<!--            <div class="checkboxs">-->
<!--              <input-->
<!--                type="checkbox"-->
<!--                id="navaidToolCheckbox"-->
<!--                name="NavaidToolCheckbox"-->
<!--                [(ngModel)]="checkboxNavaidSitingTool"-->
<!--              />-->
<!--              <label for="navaidToolCheckbox">NavAid Siting Tool</label>-->
<!--            </div>-->
<!--            <div class="checkboxs">-->
<!--              <input-->
<!--                type="checkbox"-->
<!--                id="performanceAnalysisCheckbox"-->
<!--                name="PerformanceAnalysisCheckbox"-->
<!--                [(ngModel)]="checkboxPerformanceAnalysis"-->
<!--              />-->
<!--              <label for="performanceAnalysisCheckbox">Performance Analysis</label>-->
<!--            </div>-->
<!--            <div class="checkboxs">-->
<!--              <input-->
<!--              type="checkbox"-->
<!--              id="coordenatePointsChekbox"-->
<!--              name="CoordenatePointsChekbox"-->
<!--              [(ngModel)]="checkboxCoordiantePoints"-->
<!--              />-->
<!--              <label for="coordenatePointsChekbox">Coordinate Points</label>-->
<!--            </div>-->
          </div>
          <div>
            <div class="btn" style="padding: 10px 10px 10px 0;">
              <button (click)="resetFilter()">Reset filter</button>
            </div>
            <div class="btn" style="padding: 10px 10px 10px 0;">
              <button (click)="applyFilter()">Apply filter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
